interface HudDividerProps {
	label: string;
	count?: number;
}

export function HudDivider({ label, count }: HudDividerProps) {
	return (
		<div className="hud-divider">
			<span>{label}</span>
			{count !== undefined && <span className="hud-divider__count">[{count}]</span>}
		</div>
	);
}
